<template>
  <div>
    <div style="padding:10px"></div>
    <Row>
      <Col span="4" style="text-align: right;line-height:30px;font-size:14px">
        签署文件：
      </Col>
      <Col span="20">
        <span v-if="projectInfo.Approval=='驳回'" style="color:#47cb89;line-height:30px"><Icon type="mdl-checkmark" />审批未通过，请重新编辑文件</span>
        <router-link :to="{name:fileRouteName,query:{caseId:$route.query.caseId,taskId:$route.query.taskId}}" v-if="contractSealState==false&&projectInfo.Approval!='处理中'"><Button type="primary">编辑文件</Button></router-link>
        <span v-else-if="projectInfo.Approval=='处理中'" style="color:#47cb89;line-height:30px"><Icon type="mdl-checkmark" />盖章审批中，无法编辑</span>
        <span v-else style="color:#47cb89;line-height:30px"><Icon type="mdl-checkmark" />已盖章，无法编辑</span>
      </Col>
    </Row>
    <Divider dashed />
    <Row>
      <Col span="4" style="text-align: right;line-height:30px;font-size:14px">
        委托人实名状态：
      </Col>
      <Col span="20">
        <Row v-for="(item,index) in authenticationList">
          <Col span="24" style="line-height:30px">
            {{item.name}} ：
            <template v-if="item.state==false">
              <Icon type="md-close" />未实名
              <Button type="primary" @click="authCustomer(item.id)">实名认证</Button>
              <Upload
                  :show-upload-list="false"
                  :on-success="uploadSuccess"
                  :disabled="false"
                  accept=".pdf,.png,.jpg"
                  style="display: inline-block;vertical-align:middle"
                  :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
                  :data="{MenuId:menuId,UserId:userId}"
                  :action="getServerURL('default',true)">
                <Button style="margin-left:10px" type="success" @click="clickId = item.id">线下已签署</Button>
              </Upload>
            </template>
            <template v-else>
              <span style="color:#47cb89">
                <Icon type="md-checkmark" />已认证
              </span>
            </template>
            <div style="padding:5px"></div>
          </Col>
        </Row>
      </Col>
    </Row>
    <Divider dashed />
    <Row>
      <Col span="4" style="text-align:right;line-height:30px;font-size:14px">
        委托人盖章状态：
      </Col>
      <Col span="20">
        <Row v-for="(item,index) in customerSealList">
          <Col span="24" style="line-height:30px;">
            {{item.name}} ：
            <template v-if="item.state==false&&authenticationList.find((secItem)=>{return secItem.id==item.id}).state==true">
              <Icon type="md-close"/>未签章
              <Button type="primary" @click="customerSeal(item.id)">点击签章</Button>
            </template>
            <template v-else-if="item.state==false&&authenticationList.find((secItem)=>{return secItem.id==item.id}).state==false&&parseInt(item.seal)==0">
              <span style="color:red">
                <Icon type="md-close" />等待实名
              </span>
            </template>
            <template v-else>
              <span style="color:#47cb89">
                <Icon type="md-checkmark" /><template v-if="!isEmpty(item.seal)">线下</template>已盖章
                <span v-if="!isEmpty(item.seal)&&parseInt(item.seal)!=0" style="color:#47cb89"><a :href="getServerURL('default',false)+'/'+item.src" target="_blank">点击下载</a></span>
              </span>
            </template>
            <div style="padding:5px"></div>
          </Col>
        </Row>
      </Col>
    </Row>
    <Divider dashed />
    <Row type="flex" align="middle">
      <Col span="4" style="text-align: right;line-height:30px;font-size:14px">
        盖章文件下载：
      </Col>
      <Col span="20">
        <span v-if="contractSealState==false" style="color:#ff0000">等待盖章审批中</span>
        <span v-if="contractSealState!=false" style="color:#47cb89"><Icon type="md-checkmark" />已签章 <a :href="contractSealState" target="_blank">点击下载</a></span>
      </Col>
    </Row>
    <div style="padding:10px"></div>
  </div>
</template>

<script>
  export default {
    name: "seal",
    data:function () {
      return{
        clickId:'',
        fileRouteName:'',
        authenticationList:[],
        customerSealList:[],
        contractSealState:false,
        projectInfo:{},
      }
    },
    mounted:function () {
      this.getCaseAttribute()
      this.getCustomerState()
      this.getContractContent()
      this.getProjectInfo(this.$route.query.caseId).then((res)=>{this.projectInfo = res})
    },
    methods:{
      //文件上传
      uploadSuccess:function (response,file,fileList) {
        // this.content.fileName = response.Data.name
        // this.content.filesSrc = response.Data.path
        // this.$Notice.success({
        //   title:'系统提示',
        //   desc:'文件上传成功！'
        // })
        this.updateLitigantState(this.clickId,response.Data.path)
      },
      //更新当事人状态
      updateLitigantState:function(id,src){
        var _this = this
        _this.send({
          headers:'V/UpdateLitigantState',
          data:{
            FileSrc:src,
            LitigantId:id,
            CaseId:_this.$route.query.caseId
          },
          success:function (res) {
            _this.$Notice.success({
              title:'系统消息',
              desc:'处理成功！'
            })
            _this.getCaseAttribute()
            _this.getCustomerState()
            _this.getContractContent()
          }
        })
      },
      //实名认证
      authCustomer:function(id){
        var _this = this
        _this.send({
          headers:'V/LitigantVisa',
          data:{
            LitigantId:id,
          },
          success:function (res) {
            window.location.href = res
            // window.open(res,'_blank')
          }
        })
      },
      //客户盖章
      customerSeal:function(id){
        var _this = this
        _this.send({
          headers:'V/LitigantSignature',
          data:{
            CaseId:_this.$route.query.caseId,
            LitigantId:id,
          },
          success:function (res) {
            window.location.href = res
            // window.open(res,'_blank')
          }
        })
      },
      //律所盖章
      contractSeal:function(){
        var _this = this
        _this.send({
          headers:'V/CaseSignature',
          data:{
            CaseId:_this.$route.query.caseId,
          },
          success:function (res) {
            _this.getCustomerState()
            window.open(_this.getServerURL('default',false)+'/'+res,'_blank')
          }
        })
      },
      //获取律所盖章状态
      getContractContent:function () {
        var _this = this
        _this.send({
          headers:'V/VisaFile',
          data:{
            CaseId:_this.$route.query.caseId
          },
          success:function (res) {
            if(!_this.isEmpty(res.ContractFilePath)){
              _this.contractSealState = _this.getServerURL('default',false)+'/'+res.ContractFilePath
            }else{
              _this.contractSealState = false
            }
          }
        })
      },
      //获取用户盖章状态
      getCustomerState:function(){
        var _this = this
        _this.authenticationList = []
        _this.customerSealList = []
        _this.send({
          headers:'V/VisaLitigantState',
          data:{
            CaseId:_this.$route.query.caseId
          },
          success:function (res) {
            for(var index in res){
              _this.authenticationList.push({
                state:Boolean(parseInt(res[index].Authentication)),
                name:res[index].LitigantName,
                id:res[index].LitigantId,
                seal:res[index].Visa,
                src:res[index].FileSrc,
              })
              _this.customerSealList.push({
                state:Boolean(parseInt(res[index].Visa)),
                name:res[index].LitigantName,
                id:res[index].LitigantId,
                seal:res[index].Visa,
                src:res[index].FileSrc,
              })
            }
          }
        })
      },
      //盖章文件跳转路径
      getCaseAttribute:function () {
        var _this = this
        _this.send({
          headers:'C/CaseType',
          data:{
            CaseId:_this.$route.query.caseId
          },
          success:function (res) {
            if(res.CaseTypeId==1){
              if(res.CaseClassId==1){
                _this.fileRouteName = 'projectContractAdviserCivil'
              }
              if(res.CaseClassId==2){
                _this.fileRouteName = 'projectContractAdviserAdministration'
              }
              if(res.CaseClassId==3){
                _this.fileRouteName = 'projectContractAdviserCriminal'
              }
            }
            if(res.CaseTypeId==2){
              _this.fileRouteName = 'projectContractLitigation'
            }
            if(res.CaseTypeId==3){
              _this.fileRouteName = 'projectContractSpecial'
            }
            //projectType 1诉讼 2专项 3顾问
            //projectClass 1民事 2行政 3刑事 4商经

          }
        })
      }
    },
    computed:{
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
    },
  }
</script>

<style scoped>

</style>